export class User {

    #user;

    constructor(
        user: Object,
        data: Object,
    ) {
        this.id = user.uid; // ID of user
        this.email = user.email; // Email of user
        this.emailVerified = user.emailVerified; // If user verified his email
        this.name = user.displayName; // Name of user
        this.score = data.score; // How many posts have been accepted by user

        this.#user = user; // saves the user for access to roles
    }

    async getRoles() {
        return new Promise((resolve, reject) => {
            this.#user.getIdTokenResult().then((result) => resolve(result.claims.roles)).catch(error => reject(error));
        });
    }
}

export class Exercise {
    constructor(
        id: String,
        title: String,
        creator: String,
        problem: String,
        solution: String,
        ratings: {uid: String, rating: Number},
        creationdate: Number,
        klassen: Array<Number>,
        shown: Boolean,
    ) {
        this.id = id; // ID of exercise
        this.title = title; // Short title for exercise
        this.creator = creator; // UserID of creator
        this.problem = problem; // Asked problem
        this.solution = solution; // Solution for problem
        this.ratings = ratings; // All ratings
        this.creationdate = creationdate; // Date created
        this.klassen = klassen; // Klassen the problem is aimed at
        this.shown = shown; // If the problem has been approved by moderators
    }
}